(function() {
    var currentBox;
    var currentiFrame;

    function sizePLayer(iframe) {
      var ratio = 1080/1920;

      var orientation = ratio > $(window).height() / $(window).width() ? 'animorphic' : 'wide';

      if(orientation === 'animorphic') {
        if($(window).height() <= 792) {
          iframe.style.height = $(window).height() + "px";
          iframe.style.width = $(window).height() / ratio + "px";
          iframe.classList.remove("vimeo__player--round");
        } else {
          iframe.style.height = 792 + "px";
          iframe.style.width = 792 / ratio + "px";
          iframe.classList.add("vimeo__player--round");
        }
        console.log('animporphic');
      } else {
        if($(window).width() <= 1080) {
          iframe.style.width = $(window).width() + "px";
          iframe.style.height = $(window).width() * ratio + "px";
          iframe.classList.remove("vimeo__player--round");
        } else {
          iframe.style.width = 1080 + "px";
          iframe.style.height = 1080 * ratio + "px";
          iframe.classList.add("vimeo__player--round");
        }
        console.log('wide');
      }
    }

    $(".vimeo-box").on('click', function() {
        if(currentBox)
            return;
        
        var currentBox = this;
        var id = this.dataset.href;
        var box = document.getElementById(id);
        var iframe = box.querySelector('iframe');
        var player = new Vimeo.Player(iframe);
        sizePLayer(iframe);

        window.addEventListener('resize', sizePLayer.bind(null, iframe));

        box.classList.add("open");
        player.play();

        player.on('ended', function() {  
          box.classList.remove("open");
          if (document.fullscreenElement) {
            document.exitFullscreen().catch(function(err) {  });
          }
          window.removeEventListener('resize', sizePLayer);
          currentBox = null;
        });

        $(box).on("click", function() {
          player.pause();
          box.classList.remove("open");
          window.removeEventListener('resize', sizePLayer);
          currentBox = null;
        })
    });
  })();
